function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m8.896 13.229 5.146-5.104-1.375-1.396-3.771 3.729-1.625-1.604-1.375 1.396ZM10 18.396q-1.75 0-3.271-.656-1.521-.657-2.667-1.802-1.145-1.146-1.802-2.667Q1.604 11.75 1.604 10q0-1.771.656-3.281.657-1.511 1.802-2.656Q5.208 2.917 6.729 2.26 8.25 1.604 10 1.604q1.771 0 3.281.656 1.511.657 2.657 1.803 1.145 1.145 1.802 2.656.656 1.51.656 3.281 0 1.75-.656 3.271-.657 1.521-1.802 2.667-1.146 1.145-2.657 1.802-1.51.656-3.281.656Zm0-2.042q2.667 0 4.51-1.844 1.844-1.843 1.844-4.51T14.51 5.49Q12.667 3.646 10 3.646T5.49 5.49Q3.646 7.333 3.646 10t1.844 4.51q1.843 1.844 4.51 1.844ZM10 10Z"
});

var SvgCircleCheck = function SvgCircleCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleCheck.f98fd6ca.svg";
export { ForwardRef as ReactComponent };